const EVENT_NAME = {
  USER_LOGGED_IN: 'User Logged In',
  USER_LOGGED_OUT: 'User Logged Out',
  PROMOTION_COLLECTION_CLICKED: 'Promotion Collection Clicked',
  PROMOTION_COLLECTION_VIEWED: 'Promotion Collection Viewed',
  PAGE_VIEWED: 'Page Viewed',
  PRODUCT_VIEWED: 'Product Viewed',
  PRODUCT_CLICKED: 'Product Clicked',
  PRODUCT_ADDED_TO_CART: 'Product Added To Cart',
  PRODUCT_REMOVED_FROM_CART: 'Product Removed From Cart',
  SEARCH_BAR_VIEW: 'Search Bar Viewed',
  SEARCH_COMPLETED: 'Search Completed',
  SEARCH_STARTED: 'Search Started',
  BUTTON_CLICKED: 'Button Clicked',
  VOUCHER_VIEW: 'Voucher Viewed',
  VOUCHER_APPLIED: 'Voucher Applied',
  VOUCHER_APPLICATION_FAILED: 'Voucher Application Failed',
  VOUCHER_CLICKED: 'Voucher Clicked',
  SEE_ALL_BUTTON_CLICKED: 'Button Clicked',
  DELIVERY_ADDRESS_CONFIRMED: 'Delivery Address Confirmed',
  DELIVERY_DETAILS_CONFIRMED: 'Delivery Details Confirmed',
  PAYMENT_METHOD_CONFIRMED: 'Payment Method Confirmed',
  BANNER_CLICKED: 'Banner Clicked',
  FILTER_APPLIED: 'Filter Applied',
  SORT_APPLIED: 'Sort Applied',
  CATEGORY_CLICKED: 'Category Clicked',
  BRAND_CLICKED: 'Brand Clicked',
  BANNER_VIEWED: 'Banner Viewed',
  CART_LOADED: 'Cart Loaded',
  POPUP_VIEWED: 'Popup Viewed',
  POPUP_CLICKED: 'Popup Clicked',
}

export { EVENT_NAME }
